import React from "react";
import { useSelector } from 'react-redux';
import Dropdown from "../../../../components/Dropdown";


const ProfessionSection = ({ 
    formData,
    setFormData,
    professionOptions,
    profession1Options, 
    profession2Options,
    setProfession2Options,
    profession3Options,
    setProfession3Options,
    setDisplay }: any) => {

    const { talent, errors } = useSelector((state: any) => state.talentMypage)

    const handleChangeProfessionLevel1 = (value) => {
        setFormData((prev: any) => ({
          ...prev,
          profession_1: value,
          profession_2: null,
          profession_3: null,
        }));
        setDisplay(true);
  
        // Reload options level 2
        if (value && value.code) {
            setProfession2Options(professionOptions.filter(item => item.parent_id == value.code && item.level == 2))
        } else {
            setProfession2Options([])
        }
  
        // Reload options level 3
        setProfession3Options([])
    }
  
    const handleChangeProfessionLevel2 = (value) => {
      setFormData((prev: any) => ({
        ...prev,
        profession_2: value,
        profession_3: null,
      }));
      setDisplay(true);
  
        // Reload options level 2
        if (value && value.code) {
            setProfession3Options(professionOptions.filter(item => item.parent_id == value.code && item.level == 3))
        } else {
            setProfession3Options([])
        }
    }

    return (
        <>
            <div className="flex flex-wrap gap-4 items-center mb-2">
              <p className="alu-text-base-2 text-base font-bold">経験した職種</p>
            </div>
            <div className="mt-4">
              <div className="mb-4">
                <label className="alu-text-base-2 text-sm font-bold mb-2">職種１</label>
                <Dropdown
                  error={errors?.profession_1}
                  errorText={errors?.profession_1}
                  options={profession1Options}
                  value={formData.profession_1}
                  onChange={(value: any) => handleChangeProfessionLevel1(value)}
                  placeholder="選択してください"
                  inputWidth="full"
                />
              </div>
              <div className="mb-4">
                <label className="alu-text-base-2 text-sm font-bold mb-2">職種２</label>
                <Dropdown
                  error={errors?.profession_2}
                  errorText={errors?.profession_2}
                  options={profession2Options}
                  value={formData.profession_2}
                  onChange={(value: any) => handleChangeProfessionLevel2(value)}
                  placeholder="選択してください"
                  inputWidth="full"
                  disabled={!formData.profession_1}
                />
              </div>
              <div>
                <label className="alu-text-base-2 text-sm font-bold mb-2">職種３</label>
                <Dropdown
                  error={errors?.profession_3}
                  errorText={errors?.profession_3}
                  options={profession3Options}
                  value={formData.profession_3}
                  onChange={(value: any) => {
                    setFormData((prev) => ({ ...prev, profession_3: value }));
                    setDisplay(true);
                  }}
                  placeholder="選択してください"
                  inputWidth="full"
                  disabled={!formData.profession_2}
                />
              </div>
            </div>
        </>
    )
};

export default ProfessionSection;